import React from "react";
import * as FW from "fw/system/FW";

const Footer = () => (
	<footer className="main-footer">
		<div className="pull-right hidden-xs">
			<small>
				<strong>Version </strong>
				{FW.getSettings().version} / {process.env.REACT_APP_ENV}
			</small>
		</div>
		<strong>
			{`© ${new Date().getUTCFullYear()} - `}
			<a href="https://www.primerosystems.com/" target="_blank" rel="noopener noreferrer">
				Primero Systems Inc.
			</a>
		</strong>
	</footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/layouts/main/footer/Footer.js